import { ChangeEventHandler, FC } from 'react';

import useSWR from 'swr';

import { ExportRewardsHistoryButton } from './exportRewardsHistoryButton/ExportRewardsHistoryButton';
import { RewardsHistoryTable } from './rewardsHistoryTable/RewardsHistoryTable';

import css from './RewardsHistoryPage.module.css';

import { rewardsService } from 'v2/api/rewardsService';
import { PageLayout } from 'v2/components/pageLayout/PageLayout';
import { PageTitle } from 'v2/components/pageLayout/pageTitle/PageTitle';
import { SearchTextField } from 'v2/components/searchTextField/SearchTextField';
import { useFilter } from 'v2/hooks/useFilter';
import { usePagination } from 'v2/hooks/usePagination';
import { RewardHistoryFilter } from 'v2/types/RewardModel';

export const RewardsHistoryPage: FC = () => {
  const { filter, debouncedFilter, onChange } = useFilter<RewardHistoryFilter>({
    userNickname: '',
    value: '',
    type: '',
    receivedBy: '',
  });

  const pagination = usePagination();

  const { data } = useSWR(
    ['getRewardsHistory', pagination.page, pagination.pageSize, debouncedFilter],
    rewardsService.getRewardsHistory,
    { keepPreviousData: true }
  );

  const handleFilterChange =
    (field: keyof RewardHistoryFilter): ChangeEventHandler<HTMLInputElement> =>
    (e) => {
      onChange(field, e.target.value);
    };

  return (
    <PageLayout className={css.rewardsHistoryPage} overflow="hidden">
      <PageTitle action={<ExportRewardsHistoryButton filter={filter} />}>Rewards History</PageTitle>

      <div className={css.rewardsHistoryPageContent}>
        <div className="form-group">
          <SearchTextField
            value={filter.userNickname}
            onChange={handleFilterChange('userNickname')}
            label="User Nickname"
          />

          <SearchTextField value={filter.value} onChange={handleFilterChange('value')} label="Value" />

          <SearchTextField value={filter.type} onChange={handleFilterChange('type')} label="Type" />

          <SearchTextField value={filter.receivedBy} onChange={handleFilterChange('receivedBy')} label="Received By" />
        </div>

        <RewardsHistoryTable pagination={pagination} data={data} />
      </div>
    </PageLayout>
  );
};
